module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "andrew-kim.21c4d390.jpeg" + "?" + Date.now();